type Options = {
  customClassName?: string;
  overrideCss?: boolean;
};

type GenerateCss = {
  pageContentCss: string;
  pageContentSearchTree: string;
  pageContentContainer: string;
  pageContentContent: string;
};

export const generateCss = ({
  customClassName,
  overrideCss,
}: Options = {}): GenerateCss => {
  const pageContentCss: string[] = [];
  const pageContentSearchTree: string[] = [];
  const pageContentContainer: string[] = [];
  const pageContentContent: string[] = [];

  if (!overrideCss) {
    pageContentCss.push('page-content');
    pageContentSearchTree.push('page-content__search-tree');
    pageContentContainer.push('page-content__container');
    pageContentContent.push('page-content__content');
  }

  if (customClassName) {
    pageContentCss.push(`${customClassName}`);
    pageContentSearchTree.push(`${customClassName}__search-tree`);
    pageContentContainer.push(`${customClassName}__container`);
    pageContentContent.push(`${customClassName}__content`);
  }

  return {
    pageContentCss: pageContentCss.join(' '),
    pageContentSearchTree: pageContentSearchTree.join(' '),
    pageContentContainer: pageContentContainer.join(' '),
    pageContentContent: pageContentContent.join(' '),
  };
};
